// v1.1: Exclude FAQ accordions and tab triggers from smooth scroll to prevent auto-scrolling on accordion toggle; zero blank lines
document.addEventListener('DOMContentLoaded', () => {
  // 1. For buttons with data-target
  document.querySelectorAll('.js-scroll').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const el = document.querySelector(btn.dataset.target);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  // 2. For anchor links <a href="#..."> (excluding tabs and accordions)
  document.querySelectorAll('a[href^="#"]:not([data-t4s-tab-item]):not(.t4s-accor-title):not([data-no-instant])').forEach(link => {
    if (link.closest('.t4s-tabs, .t4s-type-accordion, [data-t4s-tab-wrapper], .t4s-accordion, .mf-isolated-accordion')) {
      return;
    }
    link.addEventListener('click', e => {
      const targetId = link.getAttribute('href');
      if (targetId.length > 1) { // чтобы не ловить пустой "#"
        const el = document.querySelector(targetId);
        if (el) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
});